// extracted by mini-css-extract-plugin
module.exports = {"main":"_1410bfd27b--main--eDECl"};